<template>
  <div class="text-center" v-if="acceptRejectModal && acceptRejectModalData">
    <v-dialog
      v-model="acceptRejectModal"
      max-width="440"
      persistent
      content-class="accept-cancel-dialog"
    >
      <v-card class="confirm-modal" elevation="0" :class="variant">

        <!-- Header -->
        <div class="modal-header">
          <div class="header-left">
            <div class="header-icon-wrap">
              <v-icon :color="iconColor" size="19">{{ resolvedIcon }}</v-icon>
            </div>
            <div class="modal-title">{{ acceptRejectModalData.title }}</div>
          </div>
          <v-btn icon small @click="closeModal()" class="close-btn">
            <v-icon :color="closeColor" size="18">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <p class="modal-text mb-0">{{ acceptRejectModalData.content_a }}</p>
          <p class="modal-text mb-0 mt-2" v-if="acceptRejectModalData.content_b">{{ acceptRejectModalData.content_b }}</p>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeModal()">
            {{ acceptRejectModalData.cancelLabel || 'Cancelar' }}
          </button>
          <button class="btn-save" @click="closeModal(true)">
            <v-icon size="15" color="white" class="mr-1">mdi-check</v-icon>
            {{ acceptRejectModalData.acceptLabel || 'Aceptar' }}
          </button>
        </div>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'AcceptCancelModal',
  props: {
    closeModal: {
      type: Function,
    },
    acceptRejectModal: {
      type: Boolean,
      default: false
    },
    acceptRejectModalData: {
      type: Object,
      default: null
    }
  },
  computed: {
    variant(){
      return this.acceptRejectModalData?.type || 'primary'
    },
    resolvedIcon(){
      if(this.acceptRejectModalData?.icon) return this.acceptRejectModalData.icon
      if(this.variant === 'danger') return 'mdi-alert-octagon-outline'
      if(this.variant === 'warning-pill') return 'mdi-alert-outline'
      return 'mdi-help-circle-outline'
    },
    iconColor(){
      if(this.variant === 'danger') return '#C24D5C'
      if(this.variant === 'warning-pill') return '#8B6B3D'
      return 'white'
    },
    closeColor(){
      return this.variant === 'primary' ? 'rgba(255,255,255,0.7)' : 'rgba(45,55,75,0.4)'
    }
  },
};
</script>

<style scoped>
* { box-sizing: border-box; }

.confirm-modal.v-card {
  border-radius: 16px !important;
  overflow: hidden;
  background-color: #ffffff!important;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, #2D4B95 0%, #1a2f63 100%);
}
.header-left { display: flex; align-items: center; gap: 12px; }
.header-icon-wrap {
  width: 34px; height: 34px; border-radius: 10px;
  background: rgba(255,255,255,0.15);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.modal-title { font-size: 14px; font-weight: 600; color: #fff; line-height: 1.3; }
.close-btn { background: rgba(255,255,255,0.1) !important; border-radius: 8px !important; flex-shrink: 0; }

.modal-body { padding: 20px 22px; }
.modal-text { font-size: 13.5px; color: #4a5670; line-height: 1.6; text-align: left; }

.modal-footer {
  display: flex; align-items: center; justify-content: flex-end;
  gap: 8px; padding: 13px 22px;
  border-top: 1px solid #e8edf5; background: #f7f9fc;
}
.btn-cancel {
  padding: 8px 16px; border-radius: 8px;
  border: 1.5px solid #d1d9e8; background: transparent;
  font-size: 13px; font-weight: 500; color: #5a6a8a; cursor: pointer;
}
.btn-cancel:hover { background: #eef2fb; border-color: #b0bedd; }
.btn-save {
  display: flex; align-items: center;
  padding: 8px 18px; border-radius: 8px; border: none;
  background: linear-gradient(135deg, #2D4B95, #1a2f63);
  font-size: 13px; font-weight: 600; color: white;
  cursor: pointer; box-shadow: 0 3px 10px rgba(45,75,149,0.3);
}
.btn-save:hover { box-shadow: 0 5px 14px rgba(45,75,149,0.4); }

/* warning-pill variant — tonos suaves, header claro en vez de degradado saturado */
.confirm-modal.warning-pill .modal-header {
  background: #F6EFE2;
  border-bottom: 1px solid #EADFC8;
}
.confirm-modal.warning-pill .header-icon-wrap { background: rgba(139,107,61,0.14); }
.confirm-modal.warning-pill .modal-title { color: #4a4230; }
.confirm-modal.warning-pill .close-btn { background: rgba(45,55,75,0.06) !important; }
.confirm-modal.warning-pill .btn-save {
  background: #8B6B3D;
  box-shadow: 0 3px 10px rgba(139,107,61,0.25);
}
.confirm-modal.warning-pill .btn-save:hover { box-shadow: 0 5px 14px rgba(139,107,61,0.35); background: #7a5d34; }

/* Danger variant — tonos suaves, header claro en vez de degradado saturado */
.confirm-modal.danger .modal-header {
  background: #FBEDEF;
  border-bottom: 1px solid #F3DCE0;
}
.confirm-modal.danger .header-icon-wrap { background: rgba(194,77,92,0.14); }
.confirm-modal.danger .modal-title { color: #6b3038; }
.confirm-modal.danger .close-btn { background: rgba(45,55,75,0.06) !important; }
.confirm-modal.danger .btn-save {
  background: #C24D5C;
  box-shadow: 0 3px 10px rgba(194,77,92,0.25);
}
.confirm-modal.danger .btn-save:hover { box-shadow: 0 5px 14px rgba(194,77,92,0.35); background: #ad3f4d; }
</style>

<style>
/* v-dialog aplica max-height: 90% por defecto (teleportado fuera del scope del componente) */
.accept-cancel-dialog.v-dialog {
  max-height: 92vh;
}
</style>